var d3 = require("d3");
var $ = require('jquery');
module.exports = {
  makeParallel: function(data) {
    var draw = this.draw;
    var checkExist = setInterval(function(){
      if ($('#pc-svg').length) {
        setTimeout(function(){

          clearInterval(checkExist)
          draw(data)
        }, 100)
      }
    }, 200);
  },
  draw: function(data){
    console.log("pc data", data)
    //Source: https://bl.ocks.org/mbostock/1341021
    var width = $('#pc-svg').width();
    var height = $('#pc-svg').width();

    var x = d3.scaleBand().range([50, width]),
        y = {};

    var line = d3.line(),
        axis = d3.axisLeft(),
        background,
        foreground;

    var svg = d3.select("#pc-svg");
      svg.attr("width", width);
      svg.attr("height", height);
      svg.select('*').remove();
    var tooltip = d3.select(".tooltip")
      .style("opacity", 0);

    // Extract the list of dimensions and create a scale for each.
    var dimensions = d3.keys(data[0]).filter(function(d) {
      return d != "entity" && (y[d] = d3.scaleLinear()
          .domain(d3.extent(data, function(p) { return +p[d]; }))
          .range([height, 0]));
    });
    x.domain(dimensions);

    // Add grey background lines for context.
    var background = svg.append("g")
        .attr("class", "background")
      .selectAll("path")
        .data(data)
      .enter().append("path")
        .attr("d", path);

    // Add blue foreground lines for focus.
    var foreground = svg.append("g")
        .attr("class", "foreground")
      .selectAll("path")
        .data(data)
      .enter().append("path")
        .attr("d", path)
        .on("mouseover", function (d) {
          tooltip.html("Entity: " + d.entity + "<br>Positive: " + d.positive + "<br>Neutral: " + d.neutral + "<br>Negative: " + d.negative)
            .style("left", (d3.event.pageX+16) + "px")
            .style("top", (d3.event.pageY) + "px")
            .style("opacity", 0.9);
        });
        //.on("mouseout", function(d) {
        //  tooltip.style("opacity", 0);
        //});

    // Add a group element for each dimension.
    var g = svg.selectAll(".dimension")
        .data(dimensions)
      .enter().append("g")
        .attr("class", "dimension")
        .attr("transform", function(d) { return "translate(" + x(d) + ")"; });

    // Add an axis and title.
    g.append("g")
        .attr("class", "axis")
        .each(function(d) { d3.select(this).call(axis.scale(y[d])); })
      .append("text")
        .style("text-anchor", "middle")
        .attr("fill", "black")
        .attr("y", -9)
        .text(function(d) { return d; });

    // Returns the path for a given data point.
    function path(d) {
      return line(dimensions.map(function(p) { return [x(p), y[p](d[p])]; }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/ParallelCoord/parallel.js